import { ExternalUrls } from "./Urls";

const { BLOG_URL, CAREERS_URL, HELP_URL } = ExternalUrls;

const Redirects = [
  {
    "from": "/trybambee",
    "to": "/?utm_source=direct-mail&utm_medium=postcard&utm_content=sign-up-today&utm_campaign=prospecting-postcard-1"
  },
  {
    "from": "/careers",
    "to": CAREERS_URL
  },
  {
    "from": "/about/careers",
    "to": CAREERS_URL
  },
  {
    "from": "/trynow",
    "to": "/?play-video=true&utm_source=direct-mail&utm_medium=postie&utm_content=postcard&utm_campaign=pilot-mailer"
  },
  {
    "from": "/goosehead",
    "to": "/goosehead?utm_source=goosehead&utm_medium=partnership"
  },
  {
    "from": "/100",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=stern&utm_content=entertainment-talk"
  },
  {
    "from": "/101",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=101&utm_content=entertainment"
  },
  {
    "from": "/247",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=fox247&utm_content=news-talk"
  },
  {
    "from": "/48",
    "to": "/radio?utm_source=crossover&utm_medium=podcast&utm_campaign=48-hours&utm_content=true-crime"
  },
  {
    "from": "/ability",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=streaming-audio&utm_campaign=ability"
  },
  {
    "from": "/accidentalcreative",
    "to": "/radio?utm_source=accidental-creative&utm_medium=podcast&utm_campaign=the-accidental-creative&utm_content=careers"
  },
  {
    "from": "/activate",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=activation-network-wd&utm_content=sports"
  },
  {
    "from": "/activation",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=activation-network-we&utm_content=sports"
  },
  {
    "from": "/activation/",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=activation-network-we&utm_content=sports"
  },
  {
    "from": "/adam",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=adam-carolla&utm_content=comedy"
  },
  {
    "from": "/advantage",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=advantage&utm_content=na"
  },
  {
    "from": "/adventure",
    "to": "/radio?utm_source=public-media-marketing&utm_medium=podcast&utm_campaign=adventure-zone&utm_content=comedy"
  },
  {
    "from": "/advice",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=advice"
  },
  {
    "from": "/afford",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=afford"
  },
  {
    "from": "/agent",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=agent"
  },
  {
    "from": "/aid",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=aid"
  },
  {
    "from": "/allie",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=relatable-with-allie-beth-stuckey&utm_content=news-talk"
  },
  {
    "from": "/america",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=america&utm_content=talk"
  },
  {
    "from": "/american",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=rush&utm_content=news-talk"
  },
  {
    "from": "/andy",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=andy&utm_content=news-talk"
  },
  {
    "from": "/askpat",
    "to": "/radio?utm_source=true-native-media&utm_medium=podcast&utm_campaign=askpat&utm_content=business"
  },
  {
    "from": "/assist",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=assist"
  },
  {
    "from": "/atlantic",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=atlantic&utm_content=sports"
  },
  {
    "from": "/attack",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=attack&utm_content=sports"
  },
  {
    "from": "/audit",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=audit"
  },
  {
    "from": "/auto",
    "to": "/radio?utm_source=relay-fm&utm_medium=podcast&utm_campaign=automators&utm_content=technology"
  },
  {
    "from": "/baller",
    "to": "/radio?utm_source=cloud10-media&utm_medium=podcast&utm_campaign=baller&utm_content=business"
  },
  {
    "from": "/banks",
    "to": "/radio?utm_source=podcastad&utm_medium=podcast&utm_campaign=breaking-banks-fintech&utm_content=business"
  },
  {
    "from": "/barstool",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=barstool-sports&utm_content=sports"
  },
  {
    "from": "/basketball",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=nba-radio&utm_content=sports"
  },
  {
    "from": "/beck",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=beck&utm_content=news-talk"
  },
  {
    "from": "/ben",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=ben-shapiro-radio&utm_content=news-talk"
  },
  {
    "from": "/bill",
    "to": "/radio?utm_source=red-seat-ventures&utm_medium=podcast&utm_campaign=bill-oreillys-no-spin-news-and-analysis&utm_content=news"
  },
  {
    "from": "/blessed",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=blessed&utm_content=business"
  },
  {
    "from": "/blindlanding",
    "to": "/radio?utm_source=advertisecast-llc&utm_medium=podcast&utm_campaign=blindlanding&utm_content=society-culture"
  },
  {
    "from": "/blockedandreported",
    "to": "/radio?utm_source=katie-herzog-and-jesse-singal&utm_medium=podcast&utm_campaign=blocked-and-reported&utm_content=society-culture"
  },
  {
    "from": "/blog",
    "to": BLOG_URL
  },
  {
    "from": "/bloomberg",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=bloomberg&utm_content=talk"
  },
  {
    "from": "/blue",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=blue"
  },
  {
    "from": "/bonfire",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=comedy-central-bonfire&utm_content=comedy"
  },
  {
    "from": "/bongino",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=dan-bongino&utm_content=news-talk"
  },
  {
    "from": "/bp",
    "to": "/radio?utm_source=bigger-pockets&utm_medium=podcast&utm_campaign=biggerpockets-real-estate-podcast&utm_content=investing"
  },
  {
    "from": "/bpbusiness",
    "to": "/radio?utm_source=bigger-pockets&utm_medium=podcast&utm_campaign=biggerpockets-business-podcast&utm_content=careers"
  },
  {
    "from": "/brand",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=brand&utm_content=news-talk"
  },
  {
    "from": "/breakfast",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=barstool-breakfast&utm_content=sports"
  },
  {
    "from": "/breaking",
    "to": "/radio?utm_source=adswizz&utm_medium=podcast&utm_campaign=breaking&utm_content=politics"
  },
  {
    "from": "/brian",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=fox-news-brian-kilmeade&utm_content=news-talk"
  },
  {
    "from": "/buck",
    "to": "/radio/?utm_source=salem&utm_medium=podcast&utm_campaign=buck&utm_content=news-talk"
  },
  {
    "from": "/build",
    "to": "/radio?utm_source=advertisecast-llc&utm_medium=podcast&utm_campaign=build&utm_content=technology"
  },
  {
    "from": "/burr",
    "to": "/radio?utm_source=all-things-comedy&utm_medium=podcast&utm_campaign=burr&utm_content=comedy"
  },
  {
    "from": "/business",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=fox-business&utm_content=news-talk"
  },
  {
    "from": "/businessradio",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=businessradio&utm_content=business"
  },
  {
    "from": "/bw",
    "to": "/radio?utm_source=wondery&utm_medium=podcast&utm_campaign=bw&utm_content=business"
  },
  {
    "from": "/campaignhq",
    "to": "/radio?utm_source=cadence-13&utm_medium=podcast&utm_campaign=campaign-hq-with-david-plouffe&utm_content=society-culture"
  },
  {
    "from": "/candace",
    "to": "/radio?utm_source=wwo&utm_medium=podcast&utm_campaign=candace&utm_content=news-talk"
  },
  {
    "from": "/cbs",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=cbs-sports-plus-weekday&utm_content=sports"
  },
  {
    "from": "/chad",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=chad-prather&utm_content=news"
  },
  {
    "from": "/charlie",
    "to": "/radio?utm_source=salem&utm_medium=radio&utm_campaign=charlie-kirk&utm_content=news-talk"
  },
  {
    "from": "/chat",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=chat"
  },
  {
    "from": "/cheap",
    "to": "/radio?utm_source=circle-location-services&utm_medium=podcast&utm_campaign=cheap-heat&utm_content=sports"
  },
  {
    "from": "/cheapheat",
    "to": "/radio?utm_source=circle-location-services&utm_medium=podcast&utm_campaign=cheap-heat&utm_content=sports"
  },
  {
    "from": "/chen",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=lauren-chen&utm_content=news"
  },
  {
    "from": "/chicks",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=barstool-chics-in-the-office&utm_content=sports"
  },
  {
    "from": "/chiclets",
    "to": "/radio?utm_source=barstool&utm_medium=podcast&utm_campaign=chiclets&utm_content=sports"
  },
  {
    "from": "/chris",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=chris-plante&utm_content=news-talk"
  },
  {
    "from": "/cjr",
    "to": "/radio?utm_source=espn&utm_medium=radio&utm_campaign=espn-radio-pm-drive&utm_content=sports"
  },
  {
    "from": "/classics",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=classics&utm_content=music"
  },
  {
    "from": "/clayandbuck",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=clayandbuck&utm_content=talk"
  },
  {
    "from": "/clearedhot",
    "to": "/radio?utm_source=moonbeam-media&utm_medium=podcast&utm_campaign=cleared-hot&utm_content=society-culture"
  },
  {
    "from": "/cnbc",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=cnbc&utm_content=news-talk"
  },
  {
    "from": "/cnn",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=cnn&utm_content=news-talk"
  },
  {
    "from": "/coach",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=pac-12&utm_content=sports"
  },
  {
    "from": "/coldcase",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=cold-case&utm_content=true-crime"
  },
  {
    "from": "/college",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=college&utm_content=sports"
  },
  {
    "from": "/comedy",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=comedy-central&utm_content=comedy"
  },
  {
    "from": "/commentary",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=commentary-magazine-podcast&utm_content=news"
  },
  {
    "from": "/compass",
    "to": "/radio?utm_source=compass&utm_medium=radio&utm_campaign=compass-bonus&utm_content=news-talk"
  },
  {
    "from": "/conference",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=conference&utm_content=sports"
  },
  {
    "from": "/confidence",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=creating-confidence&utm_content=business"
  },
  {
    "from": "/congrats",
    "to": "/radio?utm_source=chank-smith&utm_medium=podcast&utm_campaign=chris-delia&utm_content=comedy"
  },
  {
    "from": "/connected",
    "to": "/radio?utm_source=relay-fm&utm_medium=podcast&utm_campaign=connected&utm_content=technology"
  },
  {
    "from": "/conservative",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=conservative-review-with-daniel-horowitz&utm_content=news-talk"
  },
  {
    "from": "/consult",
    "to": "   /radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=consult"
  },
  {
    "from": "/conway",
    "to": "   /radio?utm_source=premiere&utm_medium=radio&utm_campaign=conway&utm_content=news"
  },
  {
    "from": "/cover",
    "to": "/radio?utm_source=adswizz&utm_medium=podcast&utm_campaign=cover&utm_content=news"
  },
  {
    "from": "/crowder",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=crowder&utm_content=news-talk"
  },
  {
    "from": "/curb",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=curb&utm_content=health-fitness"
  },
  {
    "from": "/daily",
    "to": "/radio?utm_source=new-york-times-digital&utm_medium=podcast&utm_campaign=daily&utm_content=news-talk"
  },
  {
    "from": "/dan",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=dan-bongino&utm_content=news"
  },
  {
    "from": "/dana",
    "to": "   /radio?utm_source=radio_america&utm_medium=radio&utm_campaign=dana&utm_content=talk"
  },
  {
    "from": "/danashow",
    "to": "/radio?utm_source=radio-america&utm_medium=podcast&utm_campaign=danashow&utm_content=news"
  },
  {
    "from": "/data",
    "to": "/radio?utm_source=prx&utm_medium=podcast&utm_campaign=raw-data&utm_content=news"
  },
  {
    "from": "/daybreak",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=daybreak&utm_content=news-talk"
  },
  {
    "from": "/dedicated",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=ben-shapiro-radio&utm_content=news"
  },
  {
    "from": "/dennis",
    "to": "/radio?utm_source=salem&utm_medium=radio&utm_campaign=dennis-prager&utm_content=news-talk"
  },
  {
    "from": "/dial",
    "to": "/radio?utm_source=kast-media&utm_medium=podcast&utm_campaign=dial&utm_content=lifestyle"
  },
  {
    "from": "/dinesh",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=dinesh&utm_content=news-talk"
  },
  {
    "from": "/dispatch",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=dispatch&utm_content=news"
  },
  {
    "from": "/donny",
    "to": "/radio?utm_source=kast-media&utm_medium=podcast&utm_campaign=donny&utm_content=news-talk"
  },
  {
    "from": "/dp",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=dan-patrick&utm_content=sports"
  },
  {
    "from": "/dpt",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=dpt&utm_content=comedy"
  },
  {
    "from": "/dreamjob",
    "to": "/radio?utm_source=podtrac&utm_medium=podcast&utm_campaign=dont-keep-your-day-job&utm_content=business"
  },
  {
    "from": "/drlaura",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=drlaura&utm_content=news-talk"
  },
  {
    "from": "/duck",
    "to": "   /radio?utm_source=tread-lively&utm_medium=podcast&utm_campaign=duck-call-room&utm_content=news-talk"
  },
  {
    "from": "/ear",
    "to": "/radio?utm_source=cadence-13&utm_medium=podcast&utm_campaign=ear-biscuits&utm_content=comedy"
  },
  {
    "from": "/easy",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=the-odd-couple&utm_content=sports"
  },
  {
    "from": "/editors",
    "to": "/radio?utm_source=national-review&utm_medium=podcast&utm_campaign=editors&utm_content=news-talk"
  },
  {
    "from": "/effortless",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=buck-sexton&utm_content=news-talk"
  },
  {
    "from": "/ellis",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=faction-talk-ellis&utm_content=news-talk"
  },
  {
    "from": "/erick",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=the-erick-erickson-show&utm_content=news"
  },
  {
    "from": "/espn",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=espn&utm_content=sports"
  },
  {
    "from": "/espnu",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=espnu&utm_content=sports"
  },
  {
    "from": "/expert",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=expert"
  },
  {
    "from": "/ezra",
    "to": "/radio?utm_source=new-york-times-digital&utm_medium=podcast&utm_campaign=ezra&utm_content=news-talk"
  },
  {
    "from": "/faction",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=faction-talk&utm_content=news-talk"
  },
  {
    "from": "/failures",
    "to": "/radio?utm_source=advertisecast&utm_medium=podcast&utm_campaign=problem-solvers&utm_content=business"
  },
  {
    "from": "/famous",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=murder-made-me-famous&utm_content=stories"
  },
  {
    "from": "/fantasy",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=fantasy&utm_content=sports"
  },
  {
    "from": "/fem",
    "to": "/radio?utm_source=ricochet&utm_medium=podcast&utm_campaign=femsplainers&utm_content=news"
  },
  {
    "from": "/first",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=the-first-degree&utm_content=true-crime"
  },
  {
    "from": "/flash",
    "to": "/radio?utm_source=cnn&utm_medium=smart-speaker&utm_campaign=cnn-run-of-flash-briefings&utm_content=news-talk"
  },
  {
    "from": "/football",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=nfl-radio&utm_content=sports"
  },
  {
    "from": "/footballshow",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=footballshow&utm_content=sports"
  },
  {
    "from": "/fox",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=fox&utm_content=news-talk"
  },
  {
    "from": "/foxbrief",
    "to": "/radio?utm_source=fox-news&utm_medium=smart-speaker&utm_campaign=fox-brief&utm_content=business"
  },
  {
    "from": "/foxnews",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=foxnews&utm_content=news-talk"
  },
  {
    "from": "/foxsports",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=foxsports&utm_content=sports"
  },
  {
    "from": "/franken",
    "to": "/radio?utm_source=wondery&utm_medium=podcast&utm_campaign=franken&utm_content=news"
  },
  {
    "from": "/free",
    "to": "/radio?utm_source=fox-news&utm_medium=smart-speaker&utm_campaign=brief-fox-news&utm_content=news-talk"
  },
  {
    "from": "/freedom",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=beck&utm_content=news-talk"
  },
  {
    "from": "/fun",
    "to": "/radio?utm_source=espn&utm_medium=radio&utm_campaign=espn-bonus&utm_content=sports"
  },
  {
    "from": "/gabfest",
    "to": "/radio?utm_source=slate&utm_medium=podcast&utm_campaign=gabfest&utm_content=news-talk"
  },
  {
    "from": "/game",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=game&utm_content=sports"
  },
  {
    "from": "/gameday",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=cbs-sports&utm_content=sports"
  },
  {
    "from": "/getup",
    "to": "/radio?utm_source=circle-location-services&utm_medium=podcast&utm_campaign=get-up&utm_content=sports"
  },
  {
    "from": "/gladwell",
    "to": "/radio?utm_source=cadence-13&utm_medium=podcast&utm_campaign=revisionist-history&utm_content=society-culture"
  },
  {
    "from": "/glenn",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=glenn&utm_content=news-talk"
  },
  {
    "from": "/gold",
    "to": "/radio?utm_source=podtrac&utm_medium=podcast&utm_campaign=peter-schiff&utm_content=investing"
  },
  {
    "from": "/golf",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=golf&utm_content=sports"
  },
  {
    "from": "/goodlife",
    "to": "/radio?utm_source=wondery&utm_medium=podcast&utm_campaign=good-life-project&utm_content=true-crime"
  },
  {
    "from": "/gordon",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=gordon&utm_content=news-talk"
  },
  {
    "from": "/gorka",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=gorka&utm_content=news-talk"
  },
  {
    "from": "/graham",
    "to": "/radio?utm_source=sov-media&utm_medium=podcast&utm_campaign=graham&utm_content=news-talk"
  },
  {
    "from": "/greats",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=greats&utm_content=comedy"
  },
  {
    "from": "/greatness",
    "to": "/radio?utm_source=418-media&utm_medium=podcast&utm_campaign=school-of-greatness&utm_content=lifestyle"
  },
  {
    "from": "/grumpy",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=grumpy&utm_content=sports"
  },
  {
    "from": "/guide",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=guide"
  },
  {
    "from": "/guy",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=fox-news-guy-benson&utm_content=news-talk"
  },
  {
    "from": "/gw",
    "to": "/radio?utm_source=circle-location-services&utm_medium=podcast&utm_campaign=golic-and-wingo&utm_content=sports"
  },
  {
    "from": "/hack",
    "to": "/radio?utm_source=hack-the-entrepreneur&utm_medium=podcast&utm_campaign=hack-the-entrepreneur&utm_content=business"
  },
  {
    "from": "/hannity",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=hannity&utm_content=news-talk"
  },
  {
    "from": "/headlines",
    "to": "/radio?utm_source=adswizz&utm_medium=podcast&utm_campaign=headlines&utm_content=business"
  },
  {
    "from": "/help",
    "to": HELP_URL
  },
  {
    "from": "/heretics",
    "to": "/radio?utm_source=moonbeam-media-llc&utm_medium=podcast&utm_campaign=heretics&utm_content=society-culture"
  },
  {
    "from": "/hewitt",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=hewitt&utm_content=news-talk"
  },
  {
    "from": "/hln",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=cnn-hln&utm_content=news-talk"
  },
  {
    "from": "/honestly",
    "to": "/radio?utm_source=red-seat-ventures&utm_medium=podcast&utm_campaign=honestly&utm_content=news"
  },
  {
    "from": "/hoop",
    "to": "/radio?utm_source=circle-location-services&utm_medium=podcast&utm_campaign=brian-windhorst&utm_content=sports"
  },
  {
    "from": "/hopeful",
    "to": "/radio?utm_source=podtrac&utm_medium=podcast&utm_campaign=hopeful&utm_content=politics"
  },
  {
    "from": "/hours",
    "to": "/radio?utm_source=crossover&utm_medium=podcast&utm_campaign=48-hours&utm_content=true-crime"
  },
  {
    "from": "/hrhelp",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=hrhelp"
  },
  {
    "from": "/huddle",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=huddle&utm_content=sports"
  },
  {
    "from": "/hugh",
    "to": "/radio?utm_source=salem&utm_medium=radio&utm_campaign=hugh-hewitt&utm_content=news-talk"
  },
  {
    "from": "/human",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=human"
  },
  {
    "from": "/hunter",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=urban-view-hunter"
  },
  {
    "from": "/iheart",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=iheart"
  },
  {
    "from": "/impact",
    "to": "/radio?utm_source=impact-theory-llc&utm_medium=podcast&utm_campaign=impact&utm_content=news-talk"
  },
  {
    "from": "/info",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=info&utm_content=na"
  },
  {
    "from": "/intel",
    "to": "/radio?utm_source=acast&utm_medium=podcast&utm_campaign=intel&utm_content=news-talk"
  },
  {
    "from": "/investing",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=investing-in-real-estate-with-clayton-morris&utm_content=business"
  },
  {
    "from": "/james",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=the-james-altucher-show&utm_content=business"
  },
  {
    "from": "/jay",
    "to": "/radio?utm_source=kast-media&utm_medium=podcast&utm_campaign=jay-shetty&utm_content=lifestyle"
  },
  {
    "from": "/jeff",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=jeff&utm_content=society-culture"
  },
  {
    "from": "/job",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=fox-business&utm_content=news-talk"
  },
  {
    "from": "/jordan",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=jordan&utm_content=sports"
  },
  {
    "from": "/justnews",
    "to": "/radio?utm_source=crossover&utm_medium=podcast&utm_campaign=john-solomon-reports&utm_content=news-talk"
  },
  {
    "from": "/kiis",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=kiis&utm_content=music"
  },
  {
    "from": "/kirk",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=charlie-kirk&utm_content=news"
  },
  {
    "from": "/kjz",
    "to": "/radio?utm_source=espn&utm_medium=radio&utm_campaign=kjz&utm_content=sports"
  },
  {
    "from": "/klavan",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=andrew-klavan&utm_content=news"
  },
  {
    "from": "/larry",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=larry&utm_content=news-talk"
  },
  {
    "from": "/lars",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=lars-larson&utm_content=news-talk"
  },
  {
    "from": "/last",
    "to": "/radio?utm_source=rooster-teeth-productions&utm_medium=podcast&utm_campaign=last-podcast-on-the-left&utm_content=comedy"
  },
  {
    "from": "/law",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=handel-on-the-law&utm_content=news-talk"
  },
  {
    "from": "/levin",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=mark-levin&utm_content=news"
  },
  {
    "from": "/lewis",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=lewis&utm_content=news-talk"
  },
  {
    "from": "/lex",
    "to": "/radio?utm_source=moonbeam-media-llc&utm_medium=podcast&utm_campaign=lex&utm_content=technology"
  },
  {
    "from": "/liberty",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=hannity&utm_content=news-talk"
  },
  {
    "from": "/lisa",
    "to": "/radio?utm_source=headgum&utm_medium=podcast&utm_campaign=lisa&utm_content=health-fitness"
  },
  {
    "from": "/listen",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=streaming-audio&utm_campaign=listen"
  },
  {
    "from": "/liz",
    "to": "/radio?utm_source=moonbeam-media-llc&utm_medium=podcast&utm_campaign=liz&utm_content=news"
  },
  {
    "from": "/login",
    "to": `https://${ process.env.HEXAGON }/login`
  },
  {
    "from": "/login/forgot-pass",
    "to": `https://${ process.env.HEXAGON }/forgot`
  },
  {
    "from": "/london",
    "to": "/radio?utm_source=ricochet&utm_medium=podcast&utm_campaign=london-calling&utm_content=news"
  },
  {
    "from": "/longform",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=longform&utm_content=news-talk"
  },
  {
    "from": "/maddog",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=maddog&utm_content=sports"
  },
  {
    "from": "/madison",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=urban-view-madison"
  },
  {
    "from": "/majority",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=majority-report&utm_content=news"
  },
  {
    "from": "/makemesmart",
    "to": "/radio?utm_source=american-public-media&utm_medium=podcast&utm_campaign=makemesmart&utm_content=news-talk"
  },
  {
    "from": "/manager",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=manager"
  },
  {
    "from": "/marlow",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=patriot-alex-marlow&utm_content=news-talk"
  },
  {
    "from": "/market",
    "to": "/radio?utm_source=american-public-mediat&utm_medium=podcast&utm_campaign=marketplace&utm_content=business"
  },
  {
    "from": "/martini",
    "to": "/radio?utm_source=ricochet&utm_medium=podcast&utm_campaign=three-martini-lunch&utm_content=news"
  },
  {
    "from": "/matters",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=news-why-it-matters&utm_content=news"
  },
  {
    "from": "/max",
    "to": "/radio?utm_source=espn&utm_medium=radio&utm_campaign=the-max-kellerman-show&utm_content=sports"
  },
  {
    "from": "/metaxas",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=metaxas&utm_content=news-talk"
  },
  {
    "from": "/michael",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=michael-knowles&utm_content=news"
  },
  {
    "from": "/mickstape",
    "to": "/radio?utm_source=barstool&utm_medium=podcast&utm_campaign=mickstape&utm_content=sports"
  },
  {
    "from": "/mike",
    "to": "/radio?utm_source=salem&utm_medium=radio&utm_campaign=mike-gallagher&utm_content=news-talk"
  },
  {
    "from": "/mikeg",
    "to": "/radio?utm_source=salem&utm_medium=radio&utm_campaign=mike-gallagher&utm_content=news-talk"
  },
  {
    "from": "/misfit",
    "to": "/radio?utm_source=advertisecast&utm_medium=podcast&utm_campaign=misfit&utm_content=business"
  },
  {
    "from": "/mk",
    "to": "/radio?utm_source=red-seat-ventures&utm_medium=podcast&utm_campaign=the-megyn-kelly-show&utm_content=news-talk"
  },
  {
    "from": "/mkpodcast",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=mkpodcast&utm_content=news"
  },
  {
    "from": "/mmqb",
    "to": "/radio?utm_source=cadence13&utm_medium=podcast&utm_campaign=mmqb&utm_content=sports"
  },
  {
    "from": "/money",
    "to": "/radio?utm_source=fox-news&utm_medium=smart-speaker&utm_campaign=brief-fox-business&utm_content=business"
  },
  {
    "from": "/moneypit",
    "to": "/radio?utm_source=adlarge-media-llc&utm_medium=podcast&utm_campaign=moneypit&utm_content=lifestyle"
  },
  {
    "from": "/morenews",
    "to": "/radio?utm_source=kast-media&utm_medium=podcast&utm_campaign=morenews&utm_content=society-culture"
  },
  {
    "from": "/morning",
    "to": "/radio?utm_source=american-public-media&utm_medium=podcast&utm_campaign=marketplace-morning-report&utm_content=news-talk"
  },
  {
    "from": "/morninginvest",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=morninginvest&utm_content=investing"
  },
  {
    "from": "/mpu",
    "to": "/radio?utm_source=relay-fm&utm_medium=podcast&utm_campaign=mpu&utm_content=technology"
  },
  {
    "from": "/msnbc",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=msnbc&utm_content=news-talk"
  },
  {
    "from": "/mvcr",
    "to": "/radio?utm_source=compass&utm_medium=radio&utm_campaign=mvc&utm_content=news-talk"
  },
  {
    "from": "/mylett",
    "to": "/radio?utm_source=blanket-thing-media&utm_medium=podcast&utm_campaign=the-ed-mylett-show&utm_content=entrepreneurship"
  },
  {
    "from": "/nancy",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=nancy&utm_content=news-talk"
  },
  {
    "from": "/nbc",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=nbc&utm_content=sports"
  },
  {
    "from": "/nerd",
    "to": "/radio?utm_source=how-stuff-works&utm_medium=podcast&utm_campaign=nerdificent&utm_content=comedy"
  },
  {
    "from": "/network",
    "to": "/radio?utm_source=crossover&utm_medium=podcast&utm_campaign=cbs-podcast-network&utm_content=news-talk"
  },
  {
    "from": "/news",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=news-bucket&utm_content=sports"
  },
  {
    "from": "/nikki",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=comedy-central-nikki&utm_content=comedy"
  },
  {
    "from": "/now",
    "to": "/radio?utm_source=adswizz&utm_medium=podcast&utm_campaign=now&utm_content=tech"
  },
  {
    "from": "/oath",
    "to": "/radio?utm_source=wondery&utm_medium=podcast&utm_campaign=the-oath-with-chuck-rosenberg&utm_content=true-crime"
  },
  {
    "from": "/offensive",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=slightly-offensive-with-elijah-schaffer&utm_content=news-talk"
  },
  {
    "from": "/ohd",
    "to": "/radio?utm_source=advertisecast-llc&utm_medium=podcast&utm_campaign=ohd&utm_content=health-fitness"
  },
  {
    "from": "/opinions",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=opinions&utm_content=news"
  },
  {
    "from": "/orange",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=orange"
  },
  {
    "from": "/oxford",
    "to": "/radio?utm_source=oxford-road&utm_medium=podcast&utm_campaign=oxford-road-presents"
  },
  {
    "from": "/pags",
    "to": "/radio?utm_source=compass&utm_medium=radio&utm_campaign=joe-pags&utm_content=news-talk"
  },
  {
    "from": "/pandora",
    "to": "/radio?utm_source=pandora&utm_medium=streaming-audio&utm_campaign=pandora&utm_content=na"
  },
  {
    "from": "/partner",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=partner"
  },
  {
    "from": "/patriot",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=patriot&utm_content=politics"
  },
  {
    "from": "/personal",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=personal"
  },
  {
    "from": "/pivot",
    "to": "/radio?utm_source=vox-media&utm_medium=podcast&utm_campaign=pivot&utm_content=news-talk"
  },
  {
    "from": "/play",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=play&utm_content=sports"
  },
  {
    "from": "/pmt",
    "to": "/radio?utm_source=barstool&utm_medium=podcast&utm_campaign=pardon-my-take&utm_content=sports"
  },
  {
    "from": "/pockets",
    "to": "/radio?utm_source=bigger-pockets&utm_medium=podcast&utm_campaign=bigger-pockets&utm_content=business"
  },
  {
    "from": "/policy",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=policy"
  },
  {
    "from": "/pool",
    "to": "/radio?utm_source=red-seat-ventures&utm_medium=podcast&utm_campaign=pool&utm_content=news-talk"
  },
  {
    "from": "/potp",
    "to": "/radio?utm_source=gas-digital&utm_medium=podcast&utm_campaign=part-of-the-problem&utm_content=news"
  },
  {
    "from": "/potus",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=potus&utm_content=politics"
  },
  {
    "from": "/prager",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=prager&utm_content=news-talk"
  },
  {
    "from": "/prof",
    "to": "/radio?utm_source=wwo&utm_medium=podcast&utm_campaign=the-prof-g-show&utm_content=entrepreneurship"
  },
  {
    "from": "/professional",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=streaming-audio&utm_campaign=professional"
  },
  {
    "from": "/progress",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=progress&utm_content=talk"
  },
  {
    "from": "/protect",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=protect"
  },
  {
    "from": "/pstw",
    "to": "/radio?utm_source=crooked-media&utm_medium=podcast&utm_campaign=pod-save-the-world&utm_content=politics"
  },
  {
    "from": "/qa",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=qa&utm_content=news-talk"
  },
  {
    "from": "/racing",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=nascar&utm_content=sports"
  },
  {
    "from": "/ramsey",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=ramsey&utm_content=business"
  },
  {
    "from": "/reach",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=advantage-reach&utm_content=news"
  },
  {
    "from": "/realestate",
    "to": "/radio?utm_source=cash-flow-media&utm_medium=podcast&utm_campaign=realestate&utm_content=business"
  },
  {
    "from": "/redacted",
    "to": "/radio?utm_source=audioboomutm_medium=podcast&utm_campaign=redacted&utm_content=investing"
  },
  {
    "from": "/redeye",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=red-eye-radio&utm_content=news-talk"
  },
  {
    "from": "/rep",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=rep"
  },
  {
    "from": "/report",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=newstrack-weekend&utm_content=news"
  },
  {
    "from": "/reset-password",
    "to": `https://${ process.env.HEXAGON }/forgot`
  },
  {
    "from": "/resource",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=streaming-audio&utm_campaign=resource"
  },
  {
    "from": "/reuters",
    "to": "/radio/?utm_source=reuters&utm_medium=smart-speaker&utm_campaign=reuters&utm_content=news"
  },
  {
    "from": "/ricochet",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=ricochet-podcast&utm_content=news"
  },
  {
    "from": "/rickbubba",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=rick-bubba-university&utm_content=news-talk"
  },
  {
    "from": "/rickandbubba",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=rick-bubba-university&utm_content=news-talk"
  },
  {
    "from": "/ride",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=techmeme-ride-home&utm_content=news"
  },
  {
    "from": "/robertson",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=phil-robertson&utm_content=religion"
  },
  {
    "from": "/rogan",
    "to": "/radio?utm_source=public-media-marketing&utm_medium=podcast&utm_campaign=joe-rogan&utm_content=entertainment-talk"
  },
  {
    "from": "/roth",
    "to": "/radio?utm_source=ricochet&utm_medium=podcast&utm_campaign=roth-effect&utm_content=news"
  },
  {
    "from": "/roundup",
    "to": "/radio?utm_source=siriusxm&utm_medium=radio&utm_campaign=roundup&utm_content=comedy"
  },
  {
    "from": "/rubin",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=the-rubin-report&utm_content=news-talk"
  },
  {
    "from": "/rudy",
    "to": "/radio?utm_source=red-seat-ventures&utm_medium=podcast&utm_campaign=rudy&utm_content=news"
  },
  {
    "from": "/rumble",
    "to": "/radio?utm_source=anchor&utm_medium=podcast&utm_campaign=rumble&utm_content=news-talk"
  },
  {
    "from": "/rush",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=rush&utm_content=news-talk"
  },
  {
    "from": "/salem",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=bonus-salem"
  },
  {
    "from": "/savage",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=savage-nation&utm_content=news"
  },
  {
    "from": "/scale",
    "to": "/radio?utm_source=poya-ventures&utm_medium=podcast&utm_campaign=scale&utm_content=society-culture"
  },
  {
    "from": "/schnitt",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=todd-schnitt&utm_content=news-talk"
  },
  {
    "from": "/school",
    "to": "/radio?utm_source=audiolytics&utm_medium=podcast&utm_campaign=sales-school-with-jordan-belfort&utm_content=business"
  },
  {
    "from": "/science",
    "to": "/radio?utm_source=prx&utm_medium=podcast&utm_campaign=science&utm_content=news-talk"
  },
  {
    "from": "/select",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=select-talk-wd&utm_content=sports"
  },
  {
    "from": "/service",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=service"
  },
  {
    "from": "/shapiro",
    "to": "/radio?utm_source=wwo&utm_medium=podcast&utm_campaign=ben-shapiro&utm_content=news"
  },
  {
    "from": "/simple",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=outkick-the-coverage&utm_content=sports"
  },
  {
    "from": "/sisters",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=sisters&utm_content=news"
  },
  {
    "from": "/slate",
    "to": "/radio?utm_source=slate&utm_medium=podcast&utm_campaign=slate&utm_content=business"
  },
  {
    "from": "/small",
    "to": "/radio?utm_source=backbeat-media&utm_medium=podcast&utm_campaign=small&utm_content=business"
  },
  {
    "from": "/smart",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=streaming-audio&utm_campaign=smart"
  },
  {
    "from": "/smerconish",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=potus-smerconish&utm_content=politics"
  },
  {
    "from": "/soccer",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=soccer&utm_content=sports"
  },
  {
    "from": "/solution",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=podcast&utm_campaign=solution"
  },
  {
    "from": "/solve",
    "to": "/radio?utm_source=advertisecast&utm_medium=podcast&utm_campaign=problem-solvers&utm_content=business"
  },
  {
    "from": "/sports",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=espn-xtra&utm_content=sports"
  },
  {
    "from": "/spotify",
    "to": "/radio?utm_source=spotify&utm_medium=streaming-audio&utm_campaign=spotify&utm_content=na"
  },
  {
    "from": "/stapleton",
    "to": "/radio?utm_source=wwo&utm_medium=podcast&utm_campaign=wealth-power-influence&utm_content=news-talk"
  },
  {
    "from": "/start",
    "to": "/radio?utm_source=launch-partners&utm_medium=podcast&utm_campaign=this-week-in-startups&utm_content=business"
  },
  {
    "from": "/starthere",
    "to": "/radio?utm_source=circle-location-services-inc&utm_medium=podcast&utm_campaign=starthere&utm_content=news"
  },
  {
    "from": "/startup",
    "to": "/radio?utm_source=advertisecast-llc&utm_medium=podcast&utm_campaign=startup&utm_content=business"
  },
  {
    "from": "/steve",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=steve-deace-show&utm_content=news-talk"
  },
  {
    "from": "/stocks",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=cnbc&utm_content=news-talk"
  },
  {
    "from": "/story",
    "to": "/radio?utm_source=entercom&utm_medium=radio&utm_campaign=story&utm_content=news"
  },
  {
    "from": "/stream",
    "to": "/radio?utm_source=audacy&utm_medium=streaming-audio&utm_campaign=stream&utm_content=na"
  },
  {
    "from": "/stu",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=stu-does-america&utm_content=news-talk"
  },
  {
    "from": "/support",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=support"
  },
  {
    "from": "/syndicate",
    "to": "/radio?utm_source=wwo&utm_medium=podcast&utm_campaign=the-syndicate-podcast&utm_content=true-crime"
  },
  {
    "from": "/talk",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=select-talk-we&utm_content=sports"
  },
  {
    "from": "/tbtl",
    "to": "/radio?utm_source=american-public-media&utm_medium=podcast&utm_campaign=too-beautiful-to-live&utm_content=comedy"
  },
  {
    "from": "/team",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=streaming-audio&utm_campaign=team"
  },
  {
    "from": "/thom",
    "to": "/radio?utm_source=crossover&utm_medium=podcast&utm_campaign=thom&utm_content=news-talk"
  },
  {
    "from": "/tig",
    "to": "/radio?utm_source=american-public-media&utm_medium=podcast&utm_campaign=tig&utm_content=comedy"
  },
  {
    "from": "/time",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=time&utm_content=na"
  },
  {
    "from": "/timecrafting",
    "to": "/radio?utm_source=true-native-media&utm_medium=podcast&utm_campaign=productivityist&utm_content=lifestyle"
  },
  {
    "from": "/today",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=today&utm_content=news-talk"
  },
  {
    "from": "/todd",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=the-schnitt-show&utm_content=news-talk"
  },
  {
    "from": "/token",
    "to": "/radio?utm_source=barstool-sports&utm_medium=podcast&utm_campaign=token&utm_content=business"
  },
  {
    "from": "/tony",
    "to": "/radio?utm_source=podcast-ad-representation&utm_medium=podcast&utm_campaign=tony&utm_content=business"
  },
  {
    "from": "/tos/privacy",
    "to": "/legal/privacy"
  },
  {
    "from": "/townhall",
    "to": "/radio?utm_source=salem&utm_medium=podcast&utm_campaign=townhall&utm_content=news-talk"
  },
  {
    "from": "/trill",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=trill&utm_content=business"
  },
  {
    "from": "/triumph",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=triumph&utm_content=news-talk"
  },
  {
    "from": "/trust",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=fox&utm_content=news-talk"
  },
  {
    "from": "/tucker",
    "to": "/radio?utm_source=podcastone&utm_medium=podcast&utm_campaign=tucker&utm_content=sports"
  },
  {
    "from": "/uncharted",
    "to": "/radio?utm_source=poya-ventures&utm_medium=podcast&utm_campaign=uncharted&utm_content=society-culture"
  },
  {
    "from": "/undisclosed",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=undisclosed&utm_content=true-crime"
  },
  {
    "from": "/unleashed",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=pat-gray-unleashed&utm_content=news-talk"
  },
  {
    "from": "/update",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=activation-network&utm_content=news"
  },
  {
    "from": "/urban",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=urban-view"
  },
  {
    "from": "/usa",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=radiocom&utm_content=news-talk"
  },
  {
    "from": "/volume",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=volume&utm_content=sports"
  },
  {
    "from": "/wd",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=advantage-reach-wd&utm_content=sports"
  },
  {
    "from": "/weather",
    "to": "/radio/?utm_source=weather&utm_medium=smart-speaker&utm_campaign=weather&utm_content=news"
  },
  {
    "from": "/we",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=advantage-reach-we&utm_content=sports"
  },
  {
    "from": "/webb",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=patriot-webb&utm_content=politics"
  },
  {
    "from": "/weekday",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=triumph-weekday"
  },
  {
    "from": "/weekend",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=triumph-weekend"
  },
  {
    "from": "/west",
    "to": "/radio?utm_source=that-sounds-fun&utm_medium=podcast&utm_campaign=west&utm_content=news-talk"
  },
  {
    "from": "/westwood",
    "to": "/radio?utm_source=wwo&utm_medium=radio&utm_campaign=wwo-bonus&utm_content=na"
  },
  {
    "from": "/wh",
    "to": "/radio?utm_source=blaze-media&utm_medium=podcast&utm_campaign=jon-miller&utm_content=news"
  },
  {
    "from": "/whataday",
    "to": "/radio?utm_source=crooked-media&utm_medium=podcast&utm_campaign=what-a-day&utm_content=news-talk"
  },
  {
    "from": "/whitney",
    "to": "/radio?utm_source=the-paragon-collective&utm_medium=podcast&utm_campaign=whitney&utm_content=comedy"
  },
  {
    "from": "/wilkow",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=patriot-wilkow&utm_content=politics"
  },
  {
    "from": "/wolf",
    "to": "/radio?utm_source=kast-media&utm_medium=podcast&utm_campaign=wolf-den&utm_content=business"
  },
  {
    "from": "/work",
    "to": "/radio?utm_source=iheart-cpa&utm_medium=radio&utm_campaign=work"
  },
  {
    "from": "/world",
    "to": "/radio?utm_source=premiere&utm_medium=radio&utm_campaign=newstrack-weekday&utm_content=news"
  },
  {
    "from": "/wtf",
    "to": "/radio?utm_source=midroll&utm_medium=podcast&utm_campaign=wtf&utm_content=comedy"
  },
  {
    "from": "/wwo",
    "to": "/radio?utm_source=westwood-one&utm_medium=streaming-audio&utm_campaign=wwo&utm_content=sports"
  },
  {
    "from": "/xm",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=bonus&utm_content=unknown"
  },
  {
    "from": "/yak",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=barstool-yak&utm_content=sports"
  },
  {
    "from": "/z100",
    "to": "/radio?utm_source=xm&utm_medium=radio&utm_campaign=psr-whtz&utm_content=music"
  },
  {
    "from": "/assistant",
    "to": "/radio?utm_source=katz&utm_medium=streaming-audio&utm_campaign=assistant&utm_content=all"
  },
  {
    "from": "/aybg",
    "to": "/radio?utm_source=front-porch-media-network-llc&utm_medium=podcast&utm_campaign=aybg&utm_content=business"
  },
  {
    "from": "/ceocast",
    "to": "/radio?utm_source=jonekiri&utm_medium=podcast&utm_campaign=ceocast&utm_content=business"
  },
  {
    "from": "/cool",
    "to": "/radio?utm_source=advertisecast-llc&utm_medium=podcast&utm_campaign=cool&utm_content=society&culture"
  },
  {
    "from": "/csuite",
    "to": "/radio?utm_source=c-suite-network&utm_medium=podcast&utm_campaign=csuite&utm_content=business"
  },
  {
    "from": "/dan",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=dan&utm_content=news"
  },
  {
    "from": "/decoder",
    "to": "/radio?utm_source=vox-media-inc&utm_medium=podcast&utm_campaign=decoder&utm_content=business"
  },
  {
    "from": "/essential",
    "to": "/radio?utm_source=white-oak-media-llc&utm_medium=podcast&utm_campaign=essential&utm_content=education"
  },
  {
    "from": "/fake",
    "to": "/radio?utm_source=podcastone-sales&utm_medium=podcast&utm_campaign=fake&utm_content=history"
  },
  {
    "from": "/fomo",
    "to": "/radio?utm_source=white-oak-media-llc&utm_medium=podcast&utm_campaign=fomo&utm_content=business"
  },
  {
    "from": "/ftf",
    "to": "/radio?utm_source=fox-audio-network&utm_medium=podcast&utm_campaign=ftf&utm_content=sports"
  },
  {
    "from": "/gabfest",
    "to": "/radio?utm_source=slate&utm_medium=podcast&utm_campaign=gabfest&utm_content=news"
  },
  {
    "from": "/hacks",
    "to": "/radio?utm_source=white-oak-media-llc&utm_medium=podcast&utm_campaign=hacks&utm_content=business"
  },
  {
    "from": "/husband",
    "to": "/radio?utm_source=cloud10-media-llc&utm_medium=podcast&utm_campaign=husband&utm_content=truecrime"
  },
  {
    "from": "/hustle",
    "to": "/radio?utm_source=audacy&utm_medium=podcast&utm_campaign=hustle&utm_content=business"
  },
  {
    "from": "/inside",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=inside&utm_content=tv&film"
  },
  {
    "from": "/kara",
    "to": "/radio?utm_source=headgum&utm_medium=podcast&utm_campaign=kara&utm_content=business"
  },
  {
    "from": "/lab",
    "to": "/radio?utm_source=jonekiri&utm_medium=podcast&utm_campaign=lab&utm_content=business"
  },
  {
    "from": "/longform",
    "to": "/radio?utm_source=vox-media-inc&utm_medium=podcast&utm_campaign=longform&utm_content=news"
  },
  {
    "from": "/lovemurder",
    "to": "/radio?utm_source=cloud10-media-llc&utm_medium=podcast&utm_campaign=lovemurder&utm_content=truecrime"
  },
  {
    "from": "/manage",
    "to": "/radio?utm_source=wwo&utm_medium=streaming-audio&utm_campaign=manage&utm_content=news/talk/sports"
  },
  {
    "from": "/michael",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=michael&utm_content=truecrime"
  },
  {
    "from": "/office",
    "to": "/radio?utm_source=premiere&utm_medium=podcast&utm_campaign=office&utm_content=tv&film"
  },
  {
    "from": "/omnibus",
    "to": "/radio?utm_source=montecristo-llc&utm_medium=podcast&utm_campaign=omnibus&utm_content=history"
  },
  {
    "from": "/one",
    "to": "/radio?utm_source=true-native-media&utm_medium=podcast&utm_campaign=one&utm_content=business"
  },
  {
    "from": "/onion",
    "to": "/radio?utm_source=kast-media&utm_medium=podcast&utm_campaign=onion&utm_content=tv&film"
  },
  {
    "from": "/prof",
    "to": "/radio?utm_source=vox-media-inc&utm_medium=podcast&utm_campaign=prof&utm_content=business"
  },
  {
    "from": "/profiting",
    "to": "/radio?utm_source=headgum&utm_medium=podcast&utm_campaign=profiting&utm_content=education"
  },
  {
    "from": "/redhanded",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=redhanded&utm_content=truecrime"
  },
  {
    "from": "/rookie",
    "to": "/radio?utm_source=bigger-pockets&utm_medium=podcast&utm_campaign=rookie&utm_content=business"
  },
  {
    "from": "/rowe",
    "to": "/radio?utm_source=audioboom&utm_medium=podcast&utm_campaign=rowe&utm_content=society&culture"
  },
  {
    "from": "/something",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=something&utm_content=science"
  },
  {
    "from": "/tesla",
    "to": "/radio?utm_source=tunein-tesla&utm_medium=streaming-audio&utm_campaign=tesla&utm_content=all"
  },
  {
    "from": "/tides",
    "to": "/radio?utm_source=wondery&utm_medium=podcast&utm_campaign=tides&utm_content=history"
  },
  {
    "from": "/tps",
    "to": "/radio?utm_source=podtrac&utm_medium=podcast&utm_campaign=tps&utm_content=business"
  },
  {
    "from": "/underdog",
    "to": "/radio?utm_source=headgum&utm_medium=podcast&utm_campaign=underdog&utm_content=business"
  },
  {
    "from": "/walsh",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=walsh&utm_content=truecrime"
  },
  {
    "from": "/waveform",
    "to": "/radio?utm_source=vox-media-inc&utm_medium=podcast&utm_campaign=waveform&utm_content=technology"
  },
  {
    "from": "/dw",
    "to": "/radio?utm_source=westwood-one&utm_medium=podcast&utm_campaign=dw&utm_content=news "
  },
  {
    "from": "/tech",
    "to": "/radio?utm_source=fox&utm_medium=smart-speaker&utm_campaign=tech&utm_content=technology"
  },
  {
    "from": "/bannon",
    "to": "/radio?utm_source=kim-kommando-multimedia&utm_medium=email&utm_campaign=bannon&utm_content=news-talk"
  },
  {
    "from": "/morningbrew",
    "to": "/radio?utm_source=morning-brew&utm_medium=email&utm_campaign=morning-brew&utm_content=newsletter"
  },
  // Article redirects (orphaned pages - ENG-673)
  { "from": "/articles/5-biggest-payroll-problems", "to": "/" },
  { "from": "/articles/7-must-have-practices-for-hr-compliance", "to": "/" },
  { "from": "/articles/why-your-small-business-needs-bambee", "to": "/" },
  { "from": "/articles/5-policies-for-your-business-to-stay-protected", "to": "/" },
  { "from": "/articles/must-have-hr", "to": "/" },
  { "from": "/articles/test-page", "to": "/" },
  { "from": "/articles/a-new-test-page-for-draft", "to": "/" },
  { "from": "/articles/4-things-to-know-about-employee-record-retention", "to": "/" },
  { "from": "/articles/overpaying-or-underpaying-your-employees", "to": "/" },
  { "from": "/articles/the-single-best-thing-for-your-business-hr", "to": "/" },
  { "from": "/articles/feedback-goes-both-ways", "to": "/" },
  { "from": "/articles/prevent-your-employees-from-putting-your-business-at-risk", "to": "/" },
  { "from": "/articles/increase-employee-productivity", "to": "/" },
  { "from": "/articles/benefits-of-managing-hr-and-payroll", "to": "/" },
  { "from": "/articles/5-policies-for-business", "to": "/" },
  { "from": "/articles/preview", "to": "/" },
  // Insurance and PEO redirects (orphaned pages - ENG-673)
  { "from": "/insurance", "to": "/" },
  { "from": "/peo", "to": "/" }
];

export default Redirects
